import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import AnalysisTemplateTabState from './AnalysisTemplateTabState';
import EditableAnalysisTemplatePage from './EditableAnalysisTemplatePage';

export default class AnalysisTemplateTabView extends BufferTabView<AnalysisTemplateTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override render(): this {
    const props = {
      analysisTemplateId: this.model.get('analysisTemplateId'),
    };
    this.reactRoot = renderToDOM(<EditableAnalysisTemplatePage {...props} />, this.el, this.reactRoot);
    return this;
  }

  override removeAsync(callback: () => void): BufferTabView<AnalysisTemplateTabState> {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

AnalysisTemplateTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
